import swal from "sweetalert";

/**
 * Utility functions for handling notifications in Redux actions
 */

/**
 * Handle success notifications for POST, PUT, DELETE operations
 * @param {Object} response - API response object
 * @param {string} defaultMessage - Default success message
 */
export const handleSuccessNotification = (response, defaultMessage) => {
    swal("Success!", response.message || defaultMessage, "success");
};

/**
 * Handle error notifications for POST, PUT, DELETE operations
 * @param {Object} response - API response object or error
 * @param {string} defaultMessage - Default error message
 */
export const handleErrorNotification = (response, defaultMessage) => {
    const message = response?.message || response?.response?.data?.message || defaultMessage;
    swal("Error!", message, "error");
};

/**
 * Handle confirmation dialog for delete operations
 * @param {string} title - Confirmation title
 * @param {string} text - Confirmation text
 * @param {Function} onConfirm - Callback function to execute on confirmation
 */
export const handleDeleteConfirmation = (title, text, onConfirm) => {
    swal({
        title: title || "Are you sure?",
        text: text || "This action cannot be undone!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete && onConfirm) {
            onConfirm();
        }
    });
};

/**
 * Standard success notification messages
 */
export const SUCCESS_MESSAGES = {
    CREATED: "Record created successfully",
    UPDATED: "Record updated successfully", 
    DELETED: "Record deleted successfully",
    DEPOSITOR_CREATED: "Depositor created successfully 23",
    DEPOSITOR_UPDATED: "Depositor updated successfully",
    DEPOSITOR_CLOSED: "Depositor closed successfully",
    COMPANY_CREATED: "Company created successfully",
    COMPANY_UPDATED: "Company updated successfully",
    COMPANY_DELETED: "Company deleted successfully",
    BRANCH_CREATED: "Branch created successfully",
    BRANCH_UPDATED: "Branch updated successfully",
    BRANCH_DELETED: "Branch deleted successfully",
    USER_CREATED: "User created successfully",
    USER_UPDATED: "User updated successfully",
    USER_DELETED: "User deleted successfully",
    ROLE_CREATED: "Role created successfully",
    ROLE_UPDATED: "Role updated successfully",
    ROLE_DELETED: "Role deleted successfully",
    TRANSACTION_CREATED: "Transaction created successfully",
    TRANSACTION_UPDATED: "Transaction updated successfully",
    TRANSACTION_DELETED: "Transaction deleted successfully",
    KYC_SUBMITTED: "KYC document submitted successfully",
    STATUS_REFRESHED: "Status refreshed successfully",
    BULK_REFRESH_COMPLETED: "Bulk status refresh completed successfully"
};

/**
 * Standard error notification messages
 */
export const ERROR_MESSAGES = {
    CREATE_FAILED: "Failed to create record",
    UPDATE_FAILED: "Failed to update record",
    DELETE_FAILED: "Failed to delete record",
    DEPOSITOR_CREATE_FAILED: "Failed to create depositor",
    DEPOSITOR_UPDATE_FAILED: "Failed to update depositor",
    DEPOSITOR_CLOSE_FAILED: "Failed to close depositor",
    COMPANY_CREATE_FAILED: "Failed to create company",
    COMPANY_UPDATE_FAILED: "Failed to update company",
    COMPANY_DELETE_FAILED: "Failed to delete company",
    BRANCH_CREATE_FAILED: "Failed to create branch",
    BRANCH_UPDATE_FAILED: "Failed to update branch",
    BRANCH_DELETE_FAILED: "Failed to delete branch",
    USER_CREATE_FAILED: "Failed to create user",
    USER_UPDATE_FAILED: "Failed to update user",
    USER_DELETE_FAILED: "Failed to delete user",
    ROLE_CREATE_FAILED: "Failed to create role",
    ROLE_UPDATE_FAILED: "Failed to update role",
    ROLE_DELETE_FAILED: "Failed to delete role",
    TRANSACTION_CREATE_FAILED: "Failed to create transaction",
    TRANSACTION_UPDATE_FAILED: "Failed to update transaction",
    TRANSACTION_DELETE_FAILED: "Failed to delete transaction",
    KYC_SUBMIT_FAILED: "Failed to submit KYC document",
    STATUS_REFRESH_FAILED: "Failed to refresh status",
    BULK_REFRESH_FAILED: "Failed to bulk refresh statuses"
};